/**
 * German copy, English keys (admin spec D6).
 *
 * Same dot-key + {{param}} idiom the scanner PWA uses, minus the browser
 * detection: with exactly one locale, detection can only return the same
 * answer or a bug. Adding English later is adding en.json and a locale switch;
 * every call site is already correct, which is what "the seam exists from day
 * one" means.
 *
 * A missing key returns the KEY. A missing param leaves the {{placeholder}}
 * standing. Both are deliberately ugly: test/i18nKeys.test.ts fails the build
 * before either can ship, and if one ever slips through, a visible defect gets
 * reported while an empty string does not.
 */
import de from '../locales/de.json';

export const LOCALE = 'de' as const;

const strings: Record<string, string> = de;
export type TranslationKey = keyof typeof de;

export function t(key: TranslationKey, params: Record<string, string | number> = {}): string {
  const template = strings[key as string];
  if (template === undefined) return key as string;
  return template.replace(/\{\{(\w+)\}\}/g, (whole, name: string) =>
    name in params ? String(params[name]) : whole);
}
